import { cn, GridRowCheckbox } from "@qw/ui";
import type { ComponentProps, FC } from "react";

interface ConversationLinkCheckboxProps extends ComponentProps<typeof GridRowCheckbox> {
  isCurrent?: boolean;
}

export const ConversationLinkCheckbox: FC<ConversationLinkCheckboxProps> = ({ isCurrent, ...props }) => (
  <GridRowCheckbox
    {...props}
    inputProps={{
      className: cn(
        "bg-background transition-colors group-hover/conversation-link:border-primary",
        isCurrent &&
          "bg-primary border-primary-foreground/25! text-primary-foreground data-[state=checked]:bg-primary-foreground/10"
      ),
    }}
  />
);
